import { ENV, PROJECT_TYPE } from '@/constants';

export const clarityInitialization = async () => {
	if (PROJECT_TYPE.DEV) return;
	const { clarity } = await import('react-microsoft-clarity');

	const initializedClarity = clarity.hasStarted();
	if (ENV.MS_CLARITY && !initializedClarity) {
		clarity.init(ENV.MS_CLARITY);
	}
};
